// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from DrawerOverlay.module.scss  */
.DrawerOverlay-module-Root_13Y {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100%; }

.DrawerOverlay-module-Backdrop_2mC {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 63, 72, 0.8);
  animation: DrawerOverlay-module-fadein_1Xj 200ms; }

.DrawerOverlay-module-Header_2yS {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.5em 1.5em 0.4em; }

.DrawerOverlay-module-Footer_V2j {
  display: flex;
  justify-content: center;
  padding: 1em 1.5em; }
  .DrawerOverlay-module-Footer_V2j:empty {
    padding: 0 0 1em; }

.DrawerOverlay-module-Content_10e {
  overflow: hidden;
  overflow-y: auto;
  flex-grow: 1;
  max-height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .DrawerOverlay-module-Content_10e::-webkit-scrollbar {
    display: none; }

.DrawerOverlay-module-ReturnControl_2WQ {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 2.5em;
  height: 2.5em;
  font-size: inherit;
  border: none;
  background-color: transparent; }

.DrawerOverlay-module-CloseControl_3PO {
  position: absolute;
  top: -40px;
  left: calc(50% - 12px);
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  padding: 0;
  font-size: inherit;
  border: none;
  border-radius: 50%;
  outline: none;
  background: #f6f7fa;
  backdrop-filter: blur(4px); }
  .DrawerOverlay-module-CloseControl_3PO svg {
    fill: #9199a3; }

.DrawerOverlay-module-Root_13Y[aria-hidden='true'],
.DrawerOverlay-module-Root_13Y[aria-hidden='true'] .DrawerOverlay-module-Backdrop_2mC {
  visibility: hidden;
  opacity: 0;
  animation: DrawerOverlay-module-fadeout_2Up 200ms; }

.DrawerOverlay-module-overlayMode_3SU {
  width: 100%; }

@keyframes DrawerOverlay-module-fadein_1Xj {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

@keyframes DrawerOverlay-module-fadeout_2Up {
  from {
    visibility: visible;
    opacity: 1; }
  to {
    visibility: hidden;
    opacity: 0; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Drawer/DrawerOverlay/DrawerOverlay.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,YAAY,EAAE;;AAEhB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,gDAAgD,EAAE;;AAEpD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B,EAAE;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB,EAAE;EACvB;IACE,aAAa,EAAE;;AAEnB;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,6BAA6B,EAAE;;AAEjC;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0BAA0B,EAAE;EAC5B;IACE,aAAa,EAAE;;AAEnB;;EAEE,kBAAkB;EAClB,UAAU;EACV,iDAAiD,EAAE;;AAErD;EACE,WAAW,EAAE;;AAEf;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,mBAAmB;IACnB,UAAU,EAAE;EACd;IACE,kBAAkB;IAClB,UAAU,EAAE,EAAE","sourcesContent":["/*  imported from DrawerOverlay.module.scss  */\n.DrawerOverlay-module-Root_13Y {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  height: 100%; }\n\n.DrawerOverlay-module-Backdrop_2mC {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(51, 63, 72, 0.8);\n  animation: DrawerOverlay-module-fadein_1Xj 200ms; }\n\n.DrawerOverlay-module-Header_2yS {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1.5em 1.5em 0.4em; }\n\n.DrawerOverlay-module-Footer_V2j {\n  display: flex;\n  justify-content: center;\n  padding: 1em 1.5em; }\n  .DrawerOverlay-module-Footer_V2j:empty {\n    padding: 0 0 1em; }\n\n.DrawerOverlay-module-Content_10e {\n  overflow: hidden;\n  overflow-y: auto;\n  flex-grow: 1;\n  max-height: 100%;\n  -ms-overflow-style: none;\n  scrollbar-width: none; }\n  .DrawerOverlay-module-Content_10e::-webkit-scrollbar {\n    display: none; }\n\n.DrawerOverlay-module-ReturnControl_2WQ {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n  width: 2.5em;\n  height: 2.5em;\n  font-size: inherit;\n  border: none;\n  background-color: transparent; }\n\n.DrawerOverlay-module-CloseControl_3PO {\n  position: absolute;\n  top: -40px;\n  left: calc(50% - 12px);\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  margin: 0 auto;\n  padding: 0;\n  font-size: inherit;\n  border: none;\n  border-radius: 50%;\n  outline: none;\n  background: #f6f7fa;\n  backdrop-filter: blur(4px); }\n  .DrawerOverlay-module-CloseControl_3PO svg {\n    fill: #9199a3; }\n\n.DrawerOverlay-module-Root_13Y[aria-hidden='true'],\n.DrawerOverlay-module-Root_13Y[aria-hidden='true'] .DrawerOverlay-module-Backdrop_2mC {\n  visibility: hidden;\n  opacity: 0;\n  animation: DrawerOverlay-module-fadeout_2Up 200ms; }\n\n.DrawerOverlay-module-overlayMode_3SU {\n  width: 100%; }\n\n@keyframes DrawerOverlay-module-fadein_1Xj {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes DrawerOverlay-module-fadeout_2Up {\n  from {\n    visibility: visible;\n    opacity: 1; }\n  to {\n    visibility: hidden;\n    opacity: 0; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
